import { h, Fragment } from 'preact';
import { isMobile } from 'mobile-device-detect';
import FocusLock from 'react-focus-lock';

const PopupFocusLock = props => {
  return isMobile ? (
    <Fragment>{props.children}</Fragment>
  ) : (
    <FocusLock returnFocus autoFocus>
      {props.children}
    </FocusLock>
  );
};

export default PopupFocusLock;
